import React, { useState, useEffect } from 'react';
import axios from 'axios';

const RealTimeTranscription = () => {
  const [transcription, setTranscription] = useState('');
  const [recording, setRecording] = useState(false);
  const [error, setError] = useState('');

  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mediaRecorder = new MediaRecorder(stream);
      setRecording(true);
  
      mediaRecorder.ondataavailable = async (event) => {
        const formData = new FormData();
        formData.append('audio', event.data, 'audio_chunk.webm');
      
        const token = localStorage.getItem('token');
        if (!token) {
          setError('Authentication required. Please log in.');
          return;
        }
      
        try {
          const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/transcribe`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: `Bearer ${token}`,
            },
          });
          console.log('Transcription:', response.data.transcription);
          setTranscription((prev) => prev + response.data.transcription + ' ');
        } catch (err) {
          console.error('Transcription error:', err);
          setError('Failed to transcribe audio. Please try again.');
        }
      };
  
      mediaRecorder.start(5000); // Send audio chunks every 5 seconds
  
      setTimeout(() => {
        mediaRecorder.stop();
        setRecording(false);
        stream.getTracks().forEach((track) => track.stop());
      }, 60000); // Stop recording after 1 minute
    } catch (err) {
      console.error('Error accessing microphone:', err);
      setError('Could not access your microphone. Please check permissions.');
    }
  };

  return (
    <div>
      <h2>Real-Time Transcription</h2>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      <div style={{ whiteSpace: 'pre-wrap', backgroundColor: '#f4f4f4', padding: '10px', borderRadius: '5px' }}>
        {transcription || 'Start recording to see transcription here...'}
      </div>
      <button onClick={startRecording} disabled={recording}>
        {recording ? 'Recording...' : 'Start Recording'}
      </button>
    </div>
  );
};

export default RealTimeTranscription;
